import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

// This API slice is dedicated to the /documents/ path
export const documentsApi = createApi({
  reducerPath: 'documentsApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/documents/',
  }),
  endpoints: builder => ({
    exportProgramExecutiveSummaries: builder.mutation({
      query: programId => ({
        url: 'download-program-executive-summaries/',
        params: { program: programId },
        method: 'GET',
      }),
    }),
    downloadExecutiveSummary: builder.query({
      query: projectId => ({
        url: 'executive-summary/',
        params: { project_id: projectId },
        responseType: 'blob',
      }),
    }),
  }),
});

export const { useExportProgramExecutiveSummariesMutation, useLazyDownloadExecutiveSummaryQuery } =
  documentsApi;
